import { CardTag } from './commonCardTag/commonCardTag';
import Reward from './@reward/reward';
import { RegistGuideTip } from './@registGuideTip/registGuideTip';
import PCThemeDialog from './@pcThemeDialog/pcThemeDialog';
import { PcAlertDialog } from './@pcAlertDialog/pcAlertDialog';
import Pay from './@pay/pay';
import Pagination from './@pagination/pagination';
import PageSliderNavArrow from './@pageSliderNavArrow/pageSliderNavArrow';
import PageSideQrCode from './@pageSideQrCode/pageSideQrCode';
import PageQrCodeDialog from './@pageQrCodeDialog/pageQrCodeDialog';
import PagePanel from './@pagePanel/pagePanel';
import PageFooter from './@pageFooter/pageFooter';
import NotePicShare from './@notePicShare/notePicShare';
import MicroCourseNoteComposer from './@microCourseNoteComposer/microCourseNoteComposer';
import { MediaDeviceSelector } from './@mediaDeviceSelector/mediaDeviceSelector';
import { LoadAvatar, getAvatarWord } from './@loadAvatar/loadAvatar';
import LikeButton from './@likeButton/likeButton';
import keyWrodsProcessing from './@keyWrodsProcessing/keyWrodsProcessing';
import keyWrodsEmpty from './@keyWrodsEmpty/keyWrodsEmpty';
import KeywordsSection from './@keywordsSection/keywordsSection';
import WordCloud from './@keywordsSection/wordCloud/wordCloud';
import KeyWrodsEmpty from './@keyWrodsEmpty/keyWrodsEmpty';
import { WaterMark } from './@waterMark/waterMark';
import { getWordCloudData } from './@keywordsSection/wordCloudUtil';
import InfiniteScroll from './@infiniteScroll/infiniteScroll';
import { ImgCropPortal } from './@imgCropPortal/imgCropPortal';
import Iframe from './@iframe/iframe';
import { IconTips } from './@iconTips/iconTips';
import { FirstCollectDialog } from './@firstCollectDialog/firstCollectDialog';
import DocNoteComposer from './@docNoteComposer/docNoteComposer';
import docNoteComposerCommentUtil from './@docNoteComposer/commentUtil';
import CoverPopPage from './@coverPopPage/coverPopPage';
import CoverPage from './@coverPage/coverPage';
import CoursePointsBox from './@coursePointsBox/coursePointsBox';
import ConfigurableHeader from './@configurableHeader/configurableHeader';
import { ClipBoardBtn } from './@clipboardBtn/clipboardBtn';
import { ChooseDoc } from './@chooseDoc/chooseDoc';
import { AssignRangePicker } from './@assignRangePicker/assignRangePicker';
import { TimeSelect } from './@timeSelect/timeSelect';
import {UCourseShareCard} from './@uCourseShareCard';
import AiTab from './@aiTab/aiTab';
import AiReport from './@aiReport/aiReport';
import AiReportChart from './@aiReportSection/components/aiReportChart/aiReportChart';
import { Certificate } from './certificateTheme/index';
import { RangPicker, RangePicker  } from './rangPicker/index';
import { GuidePopover } from './guidePopover/guidePopover';
import BatchImport from './@batchImport/batchImport';
import _Player from "./@playerPlugin/index"
export { UmuVideoSelectorPC } from "./umuVideoSelector/umuVideoSelector"

export { default as DepartmentSelectDialog } from './@departmentSelectDialog/departmentSelectDialog';
export { default as DepartmentDropdownDialog } from './@departmentSelectDialog/departmentDropdownDialog';
export { DepartmentSearch } from './@departmentSearch/departmentSearch';
export { default as UserPostInfo } from './@userPostInfo/userPostInfo';
export const Player = _Player
export { DepartmentAndMemberSearch } from './departmentAndMemberSearch';
export const AISubtitleSetting = Player.AISubtitleSetting;
export const MoreSetting = Player.MoreSetting;
export { CourseCatalogDrawer } from './@siblingsNav/components/@courseCatalogDrawer';

import { components } from 'common';
const { TimePicker } = components;

export {
    Reward,
    RegistGuideTip,
    PCThemeDialog,
    PcAlertDialog,
    Pay,
    Pagination,
    PageSliderNavArrow,
    PageSideQrCode,
    PageQrCodeDialog,
    PagePanel,
    PageFooter,
    NotePicShare,
    MicroCourseNoteComposer,
    MediaDeviceSelector,
    LoadAvatar,
    getAvatarWord,
    LikeButton,
    keyWrodsProcessing,
    keyWrodsEmpty,
    KeywordsSection,
    KeyWrodsEmpty,
    getWordCloudData,
    WordCloud,
    WaterMark,
    InfiniteScroll,
    Iframe,
    ImgCropPortal,
    IconTips,
    FirstCollectDialog,
    DocNoteComposer,
    docNoteComposerCommentUtil,
    CoverPopPage,
    CoverPage,
    CoursePointsBox,
    ConfigurableHeader,
    ClipBoardBtn,
    ChooseDoc,
    AssignRangePicker,
    AiTab,
    AiReport,
    AiReportChart,
    TimeSelect,
    UCourseShareCard,
    Certificate,
	RangePicker,
	RangPicker,
    GuidePopover,
    BatchImport,
    CardTag,
};

export * from './imageCrop';
export * from './autoSizeEditor/autoSizeEditor';
export * from './richTextEditor';

import AiReportSection from './@aiReportSection/aiReportSection';
import { calclulateAvg, AI_DIMENTION, filterDimensions } from './@aiReportSection/util';
import { QrGenerator } from './qrCode';
import WxShare from './wxShare/wxShare';
import TopBar from './topBar/topBar';
import { TipIcon } from './tipIcon/tipIcon';
import TeacherInfo from './teacherInfo/teacherInfo';
import StarRating from './starRating/starRating';
import ShareCard from './shareCard/shareCard';
import ScrollFixed from './scrollFixed/scrollFixed';
import { EnterpriseExpireTips } from './enterpriseExpireTips/index';
import PlayControl from './playControl/playControl';
import NavBar from './navBar/navBar';
import { MoreText } from './moreText/moreText';
import { AudioMediaPlayer } from './mediaPlayer/audioMediaPlayer';
import { ImgSpareTire, spaceLogo } from './imgSpareTire/imgSpareTire';
import HeaderBannerMask from './headerBannerMask/headerBannerMask';
import { FileSelect } from './fileSelect/fileSelect';
import { ChooseCropPhoto } from './chooseCropPhoto/chooseCropPhoto';
import { AutoImg } from './autoImg/autoImg';
import AudioPlayer from './audioPlayer/audioPlayer';
import { DatePicker } from './umuDesignPicker';

// @ts-ignore
import AlloyFinger from './alloyFinger/alloyFinger.jsx';
import { WechatSubscribe } from './@wechatSubscribe/wechatSubscribe';
import UserMenu from './@userMenu/userMenu';
import { Upvote } from './@upvote/upvote';
import { UploadLoading } from './@uploadLoading/uploadLoading';
import UMUImg from './@UMUImg/UMUImg';
import { TransformersGrid } from './@transformersGrid/transformersGrid';
import TiedShareOptions from './@tiedShareOptions/tiedShareOptions';
import TextHighlightSection from './@textHighlightSection/textHighlightSection';
import SimditorText from './@simditorText/simditorText';
import SiblingsNav from './@siblingsNav/siblingsNav';
import SelectionMenu from './@selectionMenu/selectionMenu';
import SectionResultList from './@sectionResultList/sectionResultList';
import SectionParagraph from './@sectionParagraph/sectionParagraph';
import { CallAppBottomShare } from './callAppBottomShare';
import ListBlankPC from './ListBlank/ListBlankPC';
import ListBlankM from './ListBlank/ListBlankM';

export { ProfileShareCard } from './profileShareCard/profileShareCard';

export {
    AiReportSection,
    calclulateAvg,
    AI_DIMENTION,
    filterDimensions,
    QrGenerator,
    WxShare,
    TopBar,
    DatePicker,
    TipIcon,
    TeacherInfo,
    ShareCard,
    StarRating,
    ScrollFixed,
    EnterpriseExpireTips,
    PlayControl,
    NavBar,
    MoreText,
    AudioMediaPlayer,
    spaceLogo,
    ImgSpareTire,
    HeaderBannerMask,
    FileSelect,
    ChooseCropPhoto,
    AutoImg,
    AudioPlayer,
    AlloyFinger,
    WechatSubscribe,
    Upvote,
    UserMenu,
    UploadLoading,
    UMUImg,
    TransformersGrid,
    TimePicker,
    TiedShareOptions,
    TextHighlightSection,
    SimditorText,
    SiblingsNav,
    SelectionMenu,
    SectionResultList,
    SectionParagraph,
    CallAppBottomShare,
    ListBlankM,
    ListBlankPC,
};

export {
    FormCheckboxList,
    FormRdioboxList,
    SectionCheckboxList,
    SectionNumber,
    SectionRadioboxList,
    SectionTextarea,
    SurveySectionItem,
    SurveySectionList,
    DimensionLabelList,
    SurveySectionCheckbox,
    SurveySectionNumber,
    SectionRadiobox,
    SurveySectionText,
} from './@sectionList';

/**
 * account
 */
export { MailInput, PasswordInput, PhoneInput, PhoneVerification, showQuickRegisterDialog } from './account';

/**
 * dropdown menu
 */
export { Menu, MenuItem, Popover } from './dropdownMenu';

/**
 * tabs
 */
export { Tab, Tabs, TabAnchor } from './tabs';

/**
 * share card
 */
export { SharePicCard, FetchSharePic } from './share';

/**
 * user
 */
export {
    UserName,
    UmuUserName,
    UserNameRole,
    UserMedalIcon,
    UserLevelBadge,
    UserAvatar,
    TriangleUserInfo,
    UserCommentRole,
    userAchievementService,
} from './user';

